import IndifferentIcon from './component'

export default IndifferentIcon
